<template>
  <!-- Feature Section start -->
      <div class="feature-price row">
        <div class="column col-md-12">
          <h1>{{$lang.price.choose_plan}}</h1>
          <div class="price-group">

            <div class="price-container">

               <div class="price-type-selection-container"> <span class="price-type-selection" v-bind:class="{'active':subscriptionCycle === 'annual'}" @click="onCycleClicked('annual')">{{ $lang.price.annually }}</span> | <span class="price-type-selection"  v-bind:class="{'active':subscriptionCycle === 'monthly'}"  @click="onCycleClicked('monthly')">{{ $lang.price.monthly }}</span> </div>

              <div class="price-type-selection-desc">{{ $lang.price.annually_save.format(Math.round((1-discount)*100)) }}</div>
           
            </div>

            <div class="price-group-separate"></div>

            <div class="price-container">
                <div class="price-unit-type">{{$lang.payment.title_basic}}</div>
                <!-- <div class="price-unit-type-category">{{$lang.price.title_basic}}</div> -->
              <div class="price-group-header">
                <!-- <h2 class="price-group-title">{{$lang.price.basic_cost_usd}}</h2> -->
                <h2 class="price-group-title">$0</h2>
                <h2 class="price-group-title active">$0</h2>
            
                <!-- <div v-show="$lang.getLang() !== 'en-US'" class="price-alt">{{$lang.price.basic_cost_ntd}}</div> -->
                <div class="unit"><span style="color: rgb(0, 209, 178);">{{$lang.price.unit}}</span>/{{$lang.price.month}}</div>
                <!-- <div class="unit"><span style="color: rgb(0, 209, 178);">{{$lang.price.unit}}</span>/{{$lang.price.hour}}</div> -->
              </div>

              <slot name="buy-basic"></slot>
            
                <!-- <div class="list-style"><span v-html="$lang.price.basic_feature5">{{$lang.price.basic_feature5}}
                
                </span>
                
                <div style="color: #797676; font-size: 14px; font-weight: 100;">.</div>
                </div> -->
                

              <!-- <div class="seperator" style="margin:30px 0px"></div> -->

           
            </div>

            <div class="price-group-separate"></div>

            <div class="price-container">
                <div class="price-unit-type">{{$lang.price.title_premium}}</div>
                <!-- <div class="price-unit-type-category">{{$lang.payment.title_subscription}}</div> -->
              <div class="price-group-header subscription">
                <h2 class="price-group-title" v-bind:class="{'active':isYearly}" v-html="annualMonthlyPremium"></h2>
                <h2 class="price-group-title" v-bind:class="{'active':!isYearly}">{{$lang.price.premium_cost_usd}}</h2>
                <div class="unit"><span style="color: rgb(0, 209, 178);">{{$lang.price.unit}}</span>/{{$lang.price.month}}</div>
                <!-- <div v-show="$lang.getLang() !== 'en-US'" class="price-alt">{{$lang.price.premium_cost_ntd}}</div> -->
                <div v-show="$lang.getLang() !== 'en-US'" class="price-alt">${{ Math.round(monthlyPremium * (isYearly ? discount : 1) * conversionRate * (isYearly ? 12 : 1))}} {{ currencyUnit }}</div>
                <div class="price-summary" v-bind:class="{'active':isYearly}">{{$lang.price.annually_deduct.format(Math.round(monthlyPremium * (isYearly ? discount : 1) * 12))}}</div>
              </div>


              <slot name="buy-premium"></slot>
             
               <!-- <div class="list-style"><span v-html="$lang.price.premium_feature1">{{$lang.price.premium_feature1}}</span>    
                 <v-tooltip
                    :open-on-click="true"
                    transition="slide-x-transition"
                    close-delay="0"
                    content-class="landing-tooltip"
                    right
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        :size="15"
                        color="warning"
                        class="feature-info premium-price-tooltip"
                        @click.stop.prevent
                      >{{mdiHelpCircle}}</v-icon>
                    </template>
                    <span style="text-align:center">{{$lang.price.premium_feature1_tooltip}}</span>
                  </v-tooltip>
                  </div> -->


              <!-- <div class="seperator" style="margin:30px 0px"></div> -->


            </div>

            <div class="price-group-separate"></div>
            
            <div class="price-container">
                <div class="price-unit-type">{{$lang.price.title_corp}}</div>
                <!-- <div class="price-unit-type-category">{{$lang.payment.title_subscription}}</div> -->
              <div class="price-group-header subscription">
                <!-- <h2 class="price-group-title" v-html="annualMonthlyBulk"></h2>
                <h2 class="price-group-title">{{$lang.price.bulk_cost_usd}}</h2> -->

                <h2 class="price-group-title bulk" v-bind:class="{'active':isYearly}" v-html="annualMonthlyBulk"></h2>
                <h2 class="price-group-title bulk" v-bind:class="{'active':!isYearly}">{{$lang.price.bulk_cost_usd}}</h2>
                
                <div class="unit"><span style="color: rgb(0, 209, 178);">{{$lang.price.unit}}</span>/{{$lang.price.month}}</div>
                <div v-show="$lang.getLang() !== 'en-US'" class="price-alt">${{ Math.round(monthlyBulk * (isYearly ? discount : 1) * conversionRate* (isYearly ? 12 : 1))}} {{ currencyUnit }}</div>
                <div class="price-summary" v-bind:class="{'active':isYearly}">{{$lang.price.annually_deduct.format(Math.round(monthlyBulk * (isYearly ? discount : 1) * 12))}}</div>
              </div>

              <slot name="buy-bulk"></slot>
            
               <!-- <div class="list-style"><span v-html="$lang.price.premium_feature1_bulk">{{$lang.price.premium_feature1_bulk}}</span>    

                   <v-tooltip
                    :open-on-click="true"
                    transition="slide-x-transition"
                    close-delay="0"
                    content-class="landing-tooltip"
                    right
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        :size="15"
                        color="warning"
                        class="feature-info premium-price-tooltip"
                        @click.stop.prevent
                      >{{mdiHelpCircle}}</v-icon>
                    </template>
                    <span style="text-align:center" >{{$lang.price.premium_feature1_tooltip}}</span>
                  </v-tooltip>
                  </div> -->

              <!-- <div class="seperator" style="margin:30px 0px"></div> -->

            </div>
          </div>
          <!-- <div class="price-button-container">
            <button type="button" class="btn btn-custom" @click="onClick">{{$lang.price.go_to_price}}</button>
          </div> -->

          
        </div>
      </div>
  <!-- Feature Section End -->
</template>
<script>
import { mdiHelpCircle} from '@mdi/js'
//import PriceTable from "@/components/common/PriceTable";
export default {
  name: "FeatureSection",
  //components: {PriceTable},
  data() {
    return {
      discount:0.9,
      premiumUnitCost: 12,
      bulkUnitCost: 69,
      mdiHelpCircle:mdiHelpCircle,
      supportedLanguages: "",
      supportedTranslatedLanguages: "",
      promotionMinutes: '',
      corpPromotionMinutes:'',
      subscriptionCycle:'monthly'
    };
  },
  computed:{
    conversionRate(){
      const me = this;
      const language = me.$lang.getLang();

      if(language === 'en-US'){
        return 1;
      }
      else if(language === 'jp'){
        return 144
      }
      else if(language === 'kr'){
        return 1315
      }
      else if(language === 'zh'){
        return 30
      }
      else if(language === 'zh-CN'){
        return 7
      }
      else if(language === 'id'){
        return 15670;
      }
      else{
        return 0.91;
      }
    },
    currencyUnit(){
      const me = this;
      const language = me.$lang.getLang();

      if(language === 'en-US'){
        return '';
      }
      else if(language === 'jp'){
        return 'JPY'
      }
      else if(language === 'kr'){
        return 'KRW'
      }
      else if(language === 'zh'){
        return 'NTD'
      }
      else if(language === 'zh-CN'){
        return 'RMB'
      }
      else if(language === 'id'){
        return 'IDR'
      }
      else{
        return 'EUR';
      }
    },
    isYearly(){
      return this.subscriptionCycle ==='annual';
    },
    monthlyPremium(){
      const me = this;
      return me.premiumUnitCost;
    },
    monthlyBulk(){
      const me = this;
      return me.bulkUnitCost;
    },
    annualMonthlyPremium(){
      const me = this;
      let result = (me.premiumUnitCost * me.discount);
      return me.getFormatedPrice(result);
    },
    annualMonthlyBulk(){
      const me = this;
      let result = (me.bulkUnitCost * me.discount);
      return me.getFormatedPrice(result);
    }
  },
  methods: {
    getFormatedPrice(price){
      price = price.toFixed(1);
      let whole = price.split('.')[0];
      let decimal = price.split('.')[1];
      return '$'+whole +`<span style="font-size:18px">.${decimal}</span>`;
    },
    onCycleClicked(cycleType){
      this.subscriptionCycle = cycleType;
    },
    onClick() {
      const me = this;
      me.$router.push({ name: "pricing" });
    },
    distinctLanguages(languageObj){
      const distinctLang = {};
      const results = [];
      
      Object.keys(languageObj).forEach(function(code) {
        const langDisplay = languageObj[code].split(" ")[0];
        if(distinctLang[langDisplay] !== true){
          results.push(langDisplay);
          distinctLang[langDisplay] = true;
        }
      });

      return results;
    }
  },
  mounted() {
    const me = this;
    const distinctLang = me.distinctLanguages(me.$lang.language);
    const distinctTransLang = me.distinctLanguages(me.$lang.translatelanguage);

    distinctLang.forEach(function(code, index) {
      me.supportedLanguages += ('<span class="cell">' + code +'</span>'  );
      if ((index + 1) % 3 === 0) {
        me.supportedLanguages += "</br>";
      } else {
        me.supportedLanguages += " ";
      }
    });

    distinctTransLang.forEach(function(code, index) {
      me.supportedTranslatedLanguages += ('<span class="cell">' + code +'</span>'  );
      if ((index + 1) % 3 === 0) {
        me.supportedTranslatedLanguages += "</br>";
      } else {
        me.supportedTranslatedLanguages += " ";
      }
    });

    me.supportedTranslatedLanguages += `<div class="tooltip-note">*${me.$lang.price.basic_feature4_tooltip}</div>`
    me.corpPromotionMinutes = me.$lang.payment.premium_feature1.format('<span style="color: #00d1b2;">1000</span>');
    me.promotionMinutes = me.$lang.payment.premium_feature1.format('<span style="color: #00d1b2;">120</span>');
    
  }
};
</script>

<style scoped>
.feature-price{
  margin-right:8px;
}
.feature{
  background-image: url('../../assets/images/about.webp')!important;
}
.feature {
  background-image: none;
  min-height: 0px;
  margin-top: 80px !important;
}
.feature .column {
  margin: 0 auto;
}
.price-button-container{
  margin:40px;
  text-align: center;
}
.per-unit{
  font-size:14px;
  font-weight:100
}
.price-group {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 100%;
  margin-top: 60px;
  margin-right: auto;
  margin-left: auto;
  padding: 50px 0px 0px 0px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.2);
  border-radius: 6px 6px 0px 0px;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.1);
  border-bottom: 0px;
}
.price-group-separate {
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
}
.price-container {
  width: 33%;
  padding: 0px 45px;
  text-align: left;
}
.price-group-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 45px;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  color: #7f7f7f;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  position: relative;
}
/* .price-group-header.subscription{
  margin-bottom: 45px;
} */
.price-group-header div {
  color: #7f7f7f;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
}

.price-group-title {
  margin-top: 0px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #00d1b2;
  line-height: 40px;
  letter-spacing: 0px;
  text-transform: capitalize;
  opacity: 0;
  width:90px;
  transform: translateY(-50px);
  height:40px;
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}


.price-group-title.bulk{
  width:95px;
}

.price-group-title.active {
  opacity: 1;
 
  position:absolute;
  bottom:0px;
  transform: translateY(0px);
}

.price-group-header div.unit {
  font-weight: 400;
  margin-left: -10px;
}

.price-unit-type {
  color: #7f7f7f;
    font-size: 22px;
    line-height: 22px;
    margin-bottom: 15px;
    font-weight: 600;
}

.price-list {
  margin-top: 0px;
  margin-bottom: 10px;
  padding-left: 20px;
  color: #d8d8d8;
  font-size: 18px;
  line-height: 28px;
  list-style-type: disc;
}

.price-list li {
  padding-top: 4px;
  padding-bottom: 4px;
  color: #000;
  font-weight: 600;
  padding-top: 18px;
  padding-bottom: 18px;
  position: relative;
}

.price-alt{
  font-weight: 100!important;
  font-size: 13px!important;
  position:absolute;
  top:60px;
}

.price-group-header div.price-summary{
  position: absolute;
    top: 40px;
    font-size: 12px;
  opacity:0;
  transform: translateY(-40px);

  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.price-group-header div.price-summary.active{
  position: absolute;
    top: 40px;
    font-size: 12px;
  opacity:1;
  transform: translateY(0px);
}

h2 {
  margin-top: 20px;
  margin-bottom: 45px;
  color: #000;
  font-size: 40px;
  line-height: 50px;
  font-weight: 600;
}
.feature-info {
  position: absolute !important;
  top: 0px;
  right: -20px;
  z-index: 3;
  line-height: 50px !important;
}

.premium-price-tooltip{
  top:0px;
  right: 10px;
  line-height: 10px !important;
}

.price-type-selection{
  color:#797676;
  cursor: pointer;
  display:inline-block;
  padding: 0px 15px;


  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.price-type-selection.active{
  color:#2FC59F;
}

.price-type-selection-container{
  width:100%;
  text-align: center;
}

.price-type-selection-desc{
  width:100%;
  text-align: center;
  color:#00d1b2;
  font-size: 12px;
  font-weight: bold;
  margin-top: 15px;
}

.feature-price h1{
  width:100%;
  font-size: 53px;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    color: #1c2d27!important;
    text-align: center;
}

.price-group-purchase-btn.v-btn{
  color:white;
  margin-bottom:10px;
  letter-spacing: 0px;
    text-transform: capitalize;
}

@media (max-width: 992px) {
  section.feature {
    margin-top: 0px !important;
  }
  .price-group {
    display: block;
    padding: 50px 0px 10px 0px;
  }

  .price-container {
    width: 100%;
  }

  .price-group-separate {
    margin: 0 auto;
    margin-bottom: 50px;
    width: 90%;
    height: 1px;
  }

  .feature-price{
    margin-right:0px;
  }
  .feature-price .column{
    padding:0px 0px 12px 12px;
  }

}
</style>

<style>
/* .feature .btn{
  background:#3ccebd ;
  font-size: 16px;
}

.feature .btn:hover{
  background:#00e0c6 ;
} */
.tooltip-note{
  width:100%!important;
  text-align: right!important;
  font-size: 12px!important;
  margin-top:10px;
}

.list-style{
      font-size: 18px;
    line-height: 28px;
    list-style-type: disc;
    color: #000;
    font-weight: 600;
    position:relative;
}
</style>